import { z } from 'zod';
import {
  ConversationIdSchema,
  FileIdSchema,
  TenantIdSchema,
  ToolCallIdSchema,
  UserIdSchema,
} from '../ids.ts';
import { FileKindSchema } from './types.ts';

export const PlatoFileSchema = z.object({
  id: FileIdSchema,
  type: z.literal('file'),
  filename: z.string().min(1).max(255),
  mime_type: z.string().min(1).max(255),
  size_bytes: z.number().int().nonnegative(),
  created_at: z.string(),
  expires_at: z.string().nullable(),
  downloadable: z.literal(true),
  kind: FileKindSchema,
  tenant_id: TenantIdSchema,
  user_id: UserIdSchema,
  conversation_id: ConversationIdSchema,
  sha256: z.string().regex(/^[0-9a-f]{64}$/),
  origin: z.object({
    tool_call_id: ToolCallIdSchema.nullable(),
    path: z.string().max(1024),
    server: z.string().nullable(),
  }),
});
export type PlatoFile = z.infer<typeof PlatoFileSchema>;
